var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletSorter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 36,
    rx: 8,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24407 30.1271C7.64284 30.5876 8.35716 30.5876 8.75593 30.1271L11.7632 26.6547C12.3241 26.007 11.864 25 11.0073 25H4.99275C4.136 25 3.67594 26.007 4.23682 26.6547L7.24407 30.1271Z",
    fill: "#929A92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24407 5.87287C7.64284 5.41241 8.35716 5.41241 8.75593 5.87287L11.7632 9.34535C12.3241 9.99299 11.864 11 11.0073 11H4.99275C4.136 11 3.67594 9.99299 4.23682 9.34535L7.24407 5.87287Z",
    fill: "#30556B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletSorter);
export default __webpack_public_path__ + "static/media/tabletSorter.4cd8445c67253dbf91c297b40e9bea46.svg";
export { ForwardRef as ReactComponent };